import { PayloadAction } from '@reduxjs/toolkit';

export interface ApiError {
  code: number;
  field: any;
  message: string;
}

export const handleDispatchResult = async (
  res: PayloadAction<
    any,
    string,
    {
      arg: any;
      requestId: string;
      requestStatus: 'fulfilled' | 'rejected';
    },
    never
  >,
  onSuccess?: (res?: any) => void | Promise<void>,
  onComplete?: () => void | Promise<void>,
  onFailure?: (errors: ApiError[]) => void | Promise<void>
) => {
  if (res.meta.requestStatus === 'fulfilled') {
    onSuccess && (await onSuccess(res.payload as any));
  } else if (res.meta.requestStatus === 'rejected') {
    onFailure && (await onFailure(res.payload as ApiError[]));
  }

  onComplete && onComplete();

  return res;
};
